import React from "react"
// import './About.css'
import aboutUsBanner from '../assets/bannerImages/aboutUsBanner.webp'
import monitoringTheDeviation from '../assets/images/monitoringTheDeviation.webp'
import MyCard from './Mycard'
import { Link } from "react-router-dom"

import whatDoWeDo from '../assets/images/whatDoWeDo.jpg'

import soaringRevenue from '../assets/bannerImages/soaringRevenue.webp'
import brandAwareness from '../assets/bannerImages/brandAwareness.webp'
import measurableGrowth from '../assets/bannerImages/measurableGrowth.jpg'

import ourMission from '../assets/bannerImages/ourMission.jpg'
import ourVision from '../assets/bannerImages/ourVision.jpg'


export default function AboutUs(){
    return(
        <div className="aboutUs">
            <AUR1/>
            <AUR2/>
            <AUR3/>
            <AUR4/>
            <AUR5/>
            <ContactSection/>
        </div>
    )
}

function AUR1(){
    return(
        <div className="aur1">
            <h1 className="title">About Us</h1>
                <div className="overlay"/>
            <img loading="lazy" src={aboutUsBanner} className="r1-img"/>
        </div>
    )
}

function AUR2(){
    return(
        <div className="aur2">
            <img loading="lazy" src={whatDoWeDo} className="r2-img"/>
            <div className="body">
                <h1 className="head">What Do We Do?</h1>
                <p className="context">We sculpt digital experiences that resonate. At Bixian, we transform your online presence into a dynamic conversation, crafting websites that captivate, sparking engaging social dialogues, and optimizing for search to ensure you're found. We deliver precision with targeted ads, tell compelling stories through video, and nurture relationships with impactful email campaigns. Bixian orchestrates a full spectrum of digital marketing services, designed to elevate your brand and drive meaningful connections.</p>
            </div>
        </div>
    )
}

function AUR3(){
    return(
        <div className="aur3">
            <h1 className="head">How We've Helped Businesses Thrive</h1>
            <p className="context">At Bixian, success isn't just a word, it's what we deliver. 
                We've partnered with businesses across diverse industries, 
                from healthcare to real estate and restaurants, and helped them achieve remarkable results. 
                Our data-driven digital marketing strategies have driven:
            </p>
            <div className="points">
                <MyCard className='point' img={soaringRevenue} head='Soaring Revenue' description="We've helped hospitals, real estate agents, restaurants, and preschools grow, using our targeted digital campaigns."/>
                <MyCard className='point' img={brandAwareness} head='Enhanced Brand Awareness' description="We've crafted engaging content and social media strategies that have put our clients' brands on the map, leading to increased recognition and customer loyalty."/>
                <MyCard className='point' img={measurableGrowth} head='Measurable Growth' description="We track key metrics for every campaign, ensuring our clients see a clear return on their investment."/>
            </div>
        </div>
    )
}

function AUR4(){
    return(
        <div className="aur4 ourMission">
            <h1 className="head">Our Mission</h1>
            <div className="content">
                <p className="context">Our mission is more than just a statement; it's the compass that guides our every action. It defines the positive impact we strive to make in the world and the value we bring to our clients. From the very beginning of crafting our offerings to how we interact with our clients, every decision is driven by the core principles outlined in our mission statement. This ensures we remain focused on achieving a greater purpose and making a real difference for the businesses we partner with.</p>
                <img loading="lazy" src={ourMission} className="r4-img"/>
            </div>
        </div>
    )
}

function AUR5(){
    return(
        <div className="aur5 ourVision">
            <h1 className="head">Our Vision</h1>
            <div className="content">
                <img loading="lazy" src={ourVision} className="r5-img"/>
                <p className="context">Our vision is a future where the power of digital marketing is accessible and impactful for all businesses. We envision a world where companies, regardless of size or industry, can leverage innovative marketing strategies to achieve their goals and connect with their audiences in meaningful ways.</p>
            </div>
        </div>
    )
}
function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss With Us?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}